import Icon from '../components/Icon.vue'

Icon.register({
  unlink: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M304.1 405.9c4.7 4.7 4.7 12.3 0 17l-44.7 44.7c-59.3 59.3-155.7 59.3-215 0-59.3-59.3-59.3-155.7 0-215l44.7-44.7c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17l-44.7 44.7c-28.1 28.1-28.1 73.8 0 101.8 28.1 28.1 73.8 28.1 101.8 0l44.7-44.7c4.7-4.7 12.3-4.7 17 0zM247.5 145.7l-39.6-39.6c-4.7-4.7-4.7-12.3 0-17l44.7-44.7c59.3-59.3 155.7-59.3 215 0s59.3 155.7 0 215l-44.7 44.7c-4.7 4.7-12.3 4.7-17 0l-39.6-39.6c-4.7-4.7-4.7-12.3 0-17l44.7-44.7c28.1-28.1 28.1-73.8 0-101.8-28.1-28.1-73.8-28.1-101.8 0l-44.7 44.7c-4.7 4.7-12.3 4.7-17 0zM482.3 505c-9.4 9.4-24.6 9.4-33.9 0l-441.4-441.4c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l441.4 441.4c9.4 9.4 9.4 24.6 0 33.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/unlink.js
// module id = 2050
// module chunks = 0